module.exports = __webpack_public_path__ + "static/media/04.d065a325.png";